import { useEffect } from 'react'
import AppTable from '../table/AppTable'
import { useLazyQuery } from '@apollo/client';
import { TICKETS_LOG } from '../../../features/ErrorDashboard/api/ErrorQuery';
import moment from 'moment';
import ToasterWithMessage from '../toaster';
import styles from './AddTicketsError.module.css'
import { CircularProgress } from '@mui/material';
import {  formatDates } from '../../../helper';

const UserTicketsLog = (props: any) => {
    const {
          rowsPerPage,
          currentPage,
          setCurrentPage,
          checking,
          setChecking,
          manualTicketErrorList,
          setManualTicketErrorList,
          columnTypes,
          setColumnTypes,
          sortType,
          setSortType,
          selected,
          setSelected,
          datesForApiCall,
          selectedStartDate,
          selectedEndDate,
          GenerateManualTicketsErrorHeadCells,
          handleChangeRowsPerPage,
          handlePageChange
    } = props;

    const {error} = ToasterWithMessage();

    const [getUserTicketLogs, { loading }] = useLazyQuery(TICKETS_LOG, {
        fetchPolicy: "no-cache",
        onCompleted: (data) => {
            setManualTicketErrorList(data);
        },
        onError: (err) => {
            error(err?.message);
        } 
    })

    const callManualTicketsErrorApi = () => {
        const startdate = datesForApiCall.fromdate;
        const enddate = datesForApiCall.enddate;
        const formattedDates = formatDates(startdate, enddate);
        // const payloadEndDate = moment(datesForApiCall.enddate,'YYYY-MM-DD').add(1,'days');
        if(moment(startdate).isSameOrBefore(enddate,'day')){
            let payload = {};
            if(columnTypes){
                payload = {
                    "startDate": formattedDates.formattedStartDate,
                    "endDate": formattedDates.formattedEndDate,
                    "limit": rowsPerPage,
                    "offset": (currentPage -1)*rowsPerPage,
                    "order_by": {
                        [columnTypes]: sortType
                    }
                } 
            }else {
                payload = {
                    "startDate": formattedDates.formattedStartDate,
                    "endDate": formattedDates.formattedEndDate,
                    "limit": rowsPerPage,
                    "offset": (currentPage -1)*rowsPerPage,
                    "order_by": {
                        [columnTypes]: sortType
                    }
                }
            }
            getUserTicketLogs({
                variables: payload
            })
            return;
        }else {
            return;
        }
    }
    useEffect(() => {
        callManualTicketsErrorApi();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[selectedStartDate,
       selectedEndDate,
       sortType,
       columnTypes,
       rowsPerPage,
       currentPage,
    ])
    useEffect(() => {
        callManualTicketsErrorApi();
    },[])

  return (
    <>
    {
        loading
    ?
        <div className={styles.TableCircularProgress}>
        <CircularProgress color="primary" size={35} />
        </div>
    :
    <AppTable
        handleChangeRowsPerPage={handleChangeRowsPerPage}
        handlePageChange={handlePageChange}
        setColumnTypes={setColumnTypes}
        sortType={sortType}
        setSortType={setSortType}
        setChecking={setChecking}
        checking={checking}
        rowsPerPage={rowsPerPage}
        setCurrentPage={setCurrentPage}
        currentPage={currentPage}
        list={manualTicketErrorList}
        tableTitle="manualTicketsError"
        selected={selected}
        setSelected={setSelected}
        generateHeadCells={GenerateManualTicketsErrorHeadCells}
    />
    }
    </>
  )
}

export default UserTicketsLog